{ Jadelet } from @danielx/dui

// The whole chrome while performing: practice/game modes hide the edit UI
// (style.styl, app.performing) and float this play/pause + ⚙ gear cluster in
// the top-right corner over the play surface. The gear opens the mode modal
// (views/mode-modal.civet), which holds every setting that used to ride in
// the actions bar.
Template := Jadelet.exec """
  aside.mode-hud(class=@hiddenUnlessPerforming)
    button.play(click=@pause title="Play / Pause") @playIcon
    button.gear(click=@showModeModal title="Mode & settings") ⚙️
"""

export ModeHud := (player: Player) ->
  self :=
    hiddenUnlessPerforming: ->
      "hidden" if player.playMode() is "edit"

    pause: -> player.pause()

    playIcon: ->
      if player.playing() then "⏸️" else "▶️"

    showModeModal: -> player.showModeModal?()

    element: null as! HTMLElement

  self.element = Template self

  return self

export default ModeHud
